import { EnumDictionary } from 'src/app/shared/list-utils';

// list of possible question types
export enum QuizQuestionType {
    MultipleChoice = 'multiple-choice',
    SelectAnatomy = 'select-anatomy',
    LabelAnatomy = 'label-anatomy',
    Instructions = 'text-only'
}

// question type friendly names
export const questionTypesMap: EnumDictionary<QuizQuestionType, string> = {
    [QuizQuestionType.MultipleChoice]: 'Multiple Choice',
    [QuizQuestionType.SelectAnatomy]: 'Select Anatomy in 3D',
    [QuizQuestionType.LabelAnatomy]: 'Label Anatomy',
    [QuizQuestionType.Instructions]: 'Instructions'
};

// question type descriptions
export const questionDescriptionsMap: EnumDictionary<QuizQuestionType, string> = {
  [QuizQuestionType.MultipleChoice]: 'Identify the correct answer from a list of options.',
  [QuizQuestionType.SelectAnatomy]: 'Identify the correct structure(s) in the 3D model',
  [QuizQuestionType.LabelAnatomy]: 'Correctly label each structure from a list of options',
  [QuizQuestionType.Instructions]: 'Use descriptive text to provide context between questions'
};
